import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  useTheme,
  VStack
} from '@chakra-ui/react';

interface SimpleErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

const SimpleErrorModal = ({
  isOpen,
  onClose,
  title = 'Sorry',
  description = 'Something went wrong...'
}: SimpleErrorModalProps) => {
  const {
    colors: {
      palette: {
        components: { simpleErrorModal }
      }
    }
  } = useTheme();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={{ base: '3xl', md: '3xl', lg: '3xl', '3xl': '6xl' }}
      isCentered
    >
      <ModalOverlay bg={simpleErrorModal.overlayBackground} opacity='0.1' />
      <ModalContent
        overflow='hidden'
        margin='15px'
        bg='transparent'
        boxShadow='none'
      >
        <ModalBody p={0}>
          <Flex gap={0} flexDirection={{ base: 'column', md: 'row' }}>
            <VStack
              align='center'
              flex='1'
              gap={0}
              px={{ base: '30px', md: '40px', '2xl': '65px' }}
              pt={{ base: '0', md: '30px', lg: '40px', '2xl': '65px' }}
              pb={{ base: '60px', md: '40px' }}
            >
              <Text
                fontSize={{ base: '32px', md: '42px', lg: '60px' }}
                color={simpleErrorModal.titleColor}
                textAlign='center'
                mb={{ base: '25px', md: '35px', xl: '42px' }}
              >
                {title}
              </Text>
              <Text
                fontSize={{ base: '18px', md: '24px', lg: '28px' }}
                color={simpleErrorModal.descriptionColor}
                textAlign='center'
                lineHeight={1.3}
              >
                {description}
              </Text>

              <Flex
                w='100%'
                justifyContent='center'
                alignItems='center'
                mt={{ base: '30px', sm: '40px', xl: '60px' }}
              >
                <Button
                  w='180px'
                  height='45px'
                  variant='solid'
                  colorScheme='black'
                  fontSize='14px'
                  fontWeight='bold'
                  onClick={onClose}
                >
                  Back
                </Button>
              </Flex>
            </VStack>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SimpleErrorModal;
